import { ArrayInput, Button, SimpleFormIterator, useNotify, useRefresh } from "react-admin";
import EditIcon from "@mui/icons-material/Edit";
import { Typography } from "@mui/material";
import { settings } from "app";
import { erasmusRequests } from "api/erasmusApi";
import FormModal from "server/components/Modals/FormModal";
import dataProvider from "server/dataProvider";
import { InternshipIteratorItem } from "../../Partials/InternshipFields";
import { validateInternships } from "../../utils";

const toPayload = (internships = []) =>
  internships.map(internship => ({
    ...(internship?.id ? { id: internship.id } : {}),
    name: internship?.name,
    startDate: internship?.startDate,
    endDate: internship?.endDate,
    isVoluntary: Boolean(internship?.isVoluntary),
    credits: internship?.credits ?? null,
    hospitalBuildingId: internship?.hospitalBuildingId,
    employeeId: internship?.employeeId ?? null,
    externalMentorName: internship?.externalMentorName?.trim() || null,
  }));

const EditInternshipsDialog = ({ id }) => {
  const notify = useNotify();
  const refresh = useRefresh();

  const handleSave = async data => {
    await dataProvider.customRequest(
      erasmusRequests.updateIncomingInternshipStudentInternships(id),
      { internships: toPayload(data.internships) },
      "PUT",
    );
    notify("Стажовете са обновени успешно", { type: "success" });
    refresh();
  };

  return (
    <FormModal
      titleContent="Редакция на стажове"
      dialogSize="md"
      onConfirm={handleSave}
      triggerButton={
        <Button
          label="Редакция"
          variant="contained"
          startIcon={<EditIcon />}
        />
      }
    >
      <Typography
        color="error"
        mb={2}
      >
        Смяната на болницата изчиства локациите, зададени от координатора за съответния стаж. Стаж, който не е в
        списъка, се изтрива.
      </Typography>
      <ArrayInput
        source="internships"
        label={false}
        fullWidth
        validate={validateInternships}
      >
        <SimpleFormIterator
          inline={false}
          disableReordering
          sx={settings.style.iteratorWithoutGap}
        >
          <InternshipIteratorItem />
        </SimpleFormIterator>
      </ArrayInput>
    </FormModal>
  );
};

export default EditInternshipsDialog;
